import { FC } from 'react';

const SystemError: FC = () => (
    <div style={{ padding: '2rem', textAlign: 'center', color: '#b00020' }}>
        <h1>Something went wrong</h1>
        <p>We&#39;re sorry, but an unexpected error has occurred. Please try again later.</p>
    </div>
);

export default SystemError;
